import React from 'react';
import { Lightbulb } from 'lucide-react';
export function TwistSection() {
  return <section className="py-20 bg-[#234E52] text-white relative overflow-hidden" data-id="element-139">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-[#2C7A7B] rounded-full opacity-20 blur-3xl" data-id="element-140"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-96 h-96 bg-[#2C7A7B] rounded-full opacity-20 blur-3xl" data-id="element-141"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-142">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-143">
          <div className="flex-shrink-0" data-id="element-144">
            <div className="w-24 h-24 bg-[#38B2AC] rounded-full flex items-center justify-center shadow-xl" data-id="element-145">
              <Lightbulb className="w-12 h-12 text-white" data-id="element-146" />
            </div>
          </div>

          <div className="flex-1 text-center md:text-left" data-id="element-147">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#E6FFFA]" data-id="element-148">
              La Verdad Oculta
            </h2>
            <p className="text-xl leading-relaxed text-slate-100 mb-6" data-id="element-149">
              ¿Y si te dijera que el sentimiento de inutilidad es lo que te
              impide recuperarte?
            </p>
            <p className="text-lg text-slate-200 leading-relaxed" data-id="element-150">
              Tu cerebro no arranca porque lo estás golpeando con el látigo de
              la culpa. <strong data-id="element-151">No puedes construir sobre un incendio.</strong>{' '}
              Para volver a ser "productiva", primero tienes que aprender a ser
              "útil" en el silencio, en el cuidado y en la preservación de tu
              propia vida.
            </p>
          </div>
        </div>
      </div>
    </section>;
}